'use client';

import { Flex, IconButton } from '@coolblue-development/freddy';
import { Cross } from '@coolblue-development/icons';
import { useTranslation } from '@i18n/useTranslation';
import { ReactNode } from 'react';

export default function WishlistRemoveProductButton({
  onRemoveClick
}: {
  onRemoveClick(): void;
}): ReactNode {
  const { t } = useTranslation('webshop');

  return (
    <Flex justifyContent='end' sx={{ width: '100%', position: 'absolute' }}>
      <IconButton
        aria-label={t('ariaLabelRemove')}
        sx={{
          zIndex: '1'
        }}
        size={{ xs: 'large', lg: 'small' }}
        onClick={onRemoveClick}
      >
        <Cross />
      </IconButton>
    </Flex>
  );
}
